class LocalStorage {
  static getItem(key) {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      
      return null;
    }
  }

  static setItem(key, value) {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch (error) {
      
      return false;
    }
  }

  static removeItem(key) {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (error) {
      
      return false;
    }
  }

  static getObject(key) {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      
      return null;
    }
  }

  static setObject(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (error) {
      
      return false;
    }
  }

  static getUserSpecificKey(baseKey, userId) {
    return userId ? `${baseKey}_${userId}` : baseKey;
  }

  static getUserSpecificItem(baseKey, userId) {
    return this.getItem(this.getUserSpecificKey(baseKey, userId));
  }

  static setUserSpecificItem(baseKey, userId, value) {
    return this.setItem(this.getUserSpecificKey(baseKey, userId), value);
  }

  static getUserSpecificObject(baseKey, userId) {
    return this.getObject(this.getUserSpecificKey(baseKey, userId));
  }

  static setUserSpecificObject(baseKey, userId, value) {
    return this.setObject(this.getUserSpecificKey(baseKey, userId), value);
  }

  static getOrSetItem(key, defaultValue) {
    const val = this.getItem(key);
    if (val === null && defaultValue !== undefined) {
      this.setItem(key, defaultValue);
      return defaultValue;
    }
    return val;
  }

  static getOrSetUserSpecificItem(baseKey, userId, defaultValue) {
    const key = this.getUserSpecificKey(baseKey, userId);
    const val = this.getItem(key);
    if (val === null && defaultValue !== undefined) {
      this.setItem(key, defaultValue);
      return defaultValue;
    }
    return val;
  }

  static clear() {
    try {
      localStorage.clear();
      return true;
    }

    catch (error) {
      
      return false;
    }
  }
}

export default LocalStorage;
